"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var inStorePaymentForm_1 = require("../graphql/queries/inStorePaymentForm");
var react_1 = require("react");
var useInStorePaymentForm = function () {
    var _a = client_1.useQuery(inStorePaymentForm_1.default.GET_PAYMENT_FORM_SCHEMA, {
        fetchPolicy: 'cache-and-network',
    }), data = _a.data, loading = _a.loading, error = _a.error, refetch = _a.refetch;
    var _b = react_1.useState(null), formData = _b[0], setFormData = _b[1];
    var _c = react_1.useState(null), formSchema = _c[0], setFormSchema = _c[1];
    var _d = react_1.useState(null), uiSchema = _d[0], setUiSchema = _d[1];
    var _e = react_1.useState([]), requiredFields = _e[0], setRequiredFields = _e[1];
    var handleFormChange = react_1.useCallback(function (formData) {
        setFormData(formData);
    }, []);
    var getRequiredFieldsOnLoad = react_1.useCallback(function (formSchema) {
        if (!formSchema) {
            return;
        }
        var required = [];
        Object.values(formSchema).forEach(function (item) { var _a; return (required = required.concat(((_a = item) === null || _a === void 0 ? void 0 : _a.required) || [])); });
        setRequiredFields(required);
    }, []);
    react_1.useEffect(function () {
        var _a;
        if (!loading && ((_a = data) === null || _a === void 0 ? void 0 : _a.salesEnablement.paymentForm)) {
            var newJSONFormData = JSON.parse(data.salesEnablement.paymentForm.formData);
            var parsedSchema = JSON.parse(data.salesEnablement.paymentForm.schema);
            setFormSchema(parsedSchema);
            setUiSchema(JSON.parse(data.salesEnablement.paymentForm.uiSchema));
            setFormData(newJSONFormData);
            getRequiredFieldsOnLoad(parsedSchema.properties);
        }
    }, [loading, data]);
    return {
        formData: formData,
        handleFormChange: handleFormChange,
        formSchema: formSchema,
        uiSchema: uiSchema,
        requiredFields: requiredFields,
        error: error,
        refetch: refetch,
    };
};
exports.default = useInStorePaymentForm;
